/* Boutons « Ajouter » du pack série et de « Complétez la série » : ajoute au panier les variantes
   de data-db-add (sauf celles déjà dans le panier), puis rafraîchit le tiroir panier. */
(() => {
  if (window.DbPack) return;
  window.DbPack = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-db-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.classList.add('loading');
    try {
      const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
      const inCart = new Set(cart.items.map((item) => String(item.variant_id)));
      const items = button.dataset.dbAdd
        .split(',')
        .filter((id) => id && !inCart.has(id))
        .map((id) => ({ id: Number(id), quantity: 1 }));
      const drawer = document.querySelector('cart-drawer');
      const onCartPage = window.location.pathname === window.routes.cart_url;
      const body = { items };
      if (drawer && !onCartPage) body.sections = drawer.getSectionsToRender().map((section) => section.id);
      if (items.length) {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then((r) => r.json());
        if (response.status) throw new Error(response.description || response.message);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'db-pack' });
        if (body.sections) return drawer.renderContents(response);
      }
      if (onCartPage || !drawer) window.location = window.routes.cart_url;
      else drawer.open();
    } catch (error) {
      // Panier inaccessible ou variante indisponible : on laisse la page panier afficher l'état réel
      window.location = window.routes.cart_url;
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();
